// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__asDp+zcA","loader":"Loader_loader__Vlw+jaea","loaderAnimation":"Loader_loaderAnimation__crcBr8yz"};